<template>
    <div>
        <b-card >  
            <p><strong> Olá, {{usuario.firstName}} </strong></p>                              
            <div class="texto">
                <p>Bem vindo(a) à área administrativa do DOM - Diário Oficial do Município de Belo Horizonte.</p>
                <p>Aqui você pode gerenciar todo o conteúdo das edições do DOM.</p>
                <i><small>* Para realizar o processo de assinatura digital de documentos é necessário ter instalado a extensão 
                            <a href="https://get.webpkiplugin.com" target="_blank">Lacuna Web PKI</a> no seu navegador.</small></i>

            </div>            
        </b-card>        
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {    
    computed: {
        ...mapGetters({  usuario: 'userProfile'})     
    },
}
</script>

<style>
    .texto{
        color: gray;
    }
</style>



